import { useStores } from "@/hooks/use-stores";
import { useActiveStore } from "@/hooks/use-active-store";
import type { StoreType } from "@/components/layout/nav-config";

/**
 * Tip aktivne trgovine. Vraća `undefined` samo dok se trgovine učitavaju —
 * potrošači tada prikazuju stanje učitavanja, a ne maloprodajnu navigaciju
 * koja bi na tren bljesnula korisniku veleprodaje. Kad su trgovine učitane,
 * a aktivna nije odabrana ili više ne postoji (StoreSwitcher je odmah resetira
 * na prvu), ili ih uopće nema (svježa instalacija), vraća "woocommerce" da
 * navigacija uvijek postoji.
 */
export function useActiveStoreType(): StoreType | undefined {
  const { data: stores } = useStores();
  const { storeId } = useActiveStore();
  if (!stores) return undefined;
  const store = storeId ? stores.find((s: { id: string }) => s.id === storeId) : undefined;
  return (store?.storeType as StoreType | undefined) ?? "woocommerce";
}
